import axios from 'axios';
const { REACT_APP_HINT_API_BASE_URL } = process.env;

const hintApiInstance = axios.create({
   baseURL: REACT_APP_HINT_API_BASE_URL
});

export default hintApiInstance;